interface SvgProps {
  width?: React.CSSProperties["width"];
  height?: React.CSSProperties["height"];
  color?: string;
  onClick?: () => void;
}

const CrossIcon = ({
  color = "#333333",
  width = 24,
  height = 24,
  onClick,
}: SvgProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      style={{
        cursor: "pointer",
      }}
    >
      <path
        d="M12 13.2776L7.52852 17.749C7.36122 17.9163 7.14829 18 6.88973 18C6.63118 18 6.41825 17.9163 6.25095 17.749C6.08365 17.5817 6 17.3688 6 17.1103C6 16.8517 6.08365 16.6388 6.25095 16.4715L10.7224 12L6.25095 7.52852C6.08365 7.36122 6 7.14829 6 6.88973C6 6.63118 6.08365 6.41825 6.25095 6.25095C6.41825 6.08365 6.63118 6 6.88973 6C7.14829 6 7.36122 6.08365 7.52852 6.25095L12 10.7224L16.4715 6.25095C16.6388 6.08365 16.8517 6 17.1103 6C17.3688 6 17.5817 6.08365 17.749 6.25095C17.9163 6.41825 18 6.63118 18 6.88973C18 7.14829 17.9163 7.36122 17.749 7.52852L13.2776 12L17.749 16.4715C17.9163 16.6388 18 16.8517 18 17.1103C18 17.3688 17.9163 17.5817 17.749 17.749C17.5817 17.9163 17.3688 18 17.1103 18C16.8517 18 16.6388 17.9163 16.4715 17.749L12 13.2776Z"
        fill={color}
      />
    </svg>
  );
};

export default CrossIcon;
